import image001 from "images/sushi/menu/takeaway/image001.png";
import image003 from "images/sushi/menu/takeaway/image003.png";
import image005 from "images/sushi/menu/takeaway/image005.png";
import image007 from "images/sushi/menu/takeaway/image007.png";
import image009 from "images/sushi/menu/takeaway/image009.png";
import image011 from "images/sushi/menu/takeaway/image011.png";
import image013 from "images/sushi/menu/takeaway/image013.png";
import image015 from "images/sushi/menu/takeaway/image015.png";
import image017 from "images/sushi/menu/takeaway/image017.png";
import image019 from "images/sushi/menu/takeaway/image019.png";
import image021 from "images/sushi/menu/takeaway/image021.png";
import image023 from "images/sushi/menu/takeaway/image023.png";
import image025 from "images/sushi/menu/takeaway/image025.png";
import image027 from "images/sushi/menu/takeaway/image027.png";
import image029 from "images/sushi/menu/takeaway/image029.png";
import image031 from "images/sushi/menu/takeaway/image031.png";
import image033 from "images/sushi/menu/takeaway/image033.png";
import image035 from "images/sushi/menu/takeaway/image035.png";
import image037 from "images/sushi/menu/takeaway/image037.png";
import image039 from "images/sushi/menu/takeaway/image039.png";
import image041 from "images/sushi/menu/takeaway/image041.png";
import image043 from "images/sushi/menu/takeaway/image043.png";
import image045 from "images/sushi/menu/takeaway/image045.png";
import image047 from "images/sushi/menu/takeaway/image047.png";
import image049 from "images/sushi/menu/takeaway/image049.png";
import image051 from "images/sushi/menu/takeaway/image051.png";
import image053 from "images/sushi/menu/takeaway/image053.png";
import image055 from "images/sushi/menu/takeaway/image055.png";
import image057 from "images/sushi/menu/takeaway/image057.png";
import image059 from "images/sushi/menu/takeaway/image059.png";
import image061 from "images/sushi/menu/takeaway/image061.png";
import image063 from "images/sushi/menu/takeaway/image063.png";
import image065 from "images/sushi/menu/takeaway/image065.png";
import image067 from "images/sushi/menu/takeaway/image067.png";
import image069 from "images/sushi/menu/takeaway/image069.png";
import image071 from "images/sushi/menu/takeaway/image071.png";
import image073 from "images/sushi/menu/takeaway/image073.png";
import image075 from "images/sushi/menu/takeaway/image075.png";
import image077 from "images/sushi/menu/takeaway/image077.png";
import image079 from "images/sushi/menu/takeaway/image079.png";
import image081 from "images/sushi/menu/takeaway/image081.png";
import image083 from "images/sushi/menu/takeaway/image083.png";
import image085 from "images/sushi/menu/takeaway/image085.png";
import image087 from "images/sushi/menu/takeaway/image087.png";
import image089 from "images/sushi/menu/takeaway/image089.png";
import image091 from "images/sushi/menu/takeaway/image091.png";
import image093 from "images/sushi/menu/takeaway/image093.png";
import image095 from "images/sushi/menu/takeaway/image095.png";
import image097 from "images/sushi/menu/takeaway/image097.png";
import image099 from "images/sushi/menu/takeaway/image099.png";
import image101 from "images/sushi/menu/takeaway/image101.png";
import image103 from "images/sushi/menu/takeaway/image103.png";

import menuItemDefaultImg from "images/sushi/logo-only.png";


/* This function is only there for demo purposes. It populates placeholder cards */
export const getRandomCards = () => {
    const cards = [
        {
            imageSrc:
                "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Chicken Chilled",
            content: "Chicken Main Course",
            price: "£5.99",
            rating: "5.00",
            reviews: "87",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1582254465498-6bc70419b607?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Samsa Beef",
            content: "Fried Mexican Beef",
            price: "£3.99",
            rating: "4.5",
            reviews: "34",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1565310022184-f23a884f29da?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Carnet Nachos",
            content: "Chilli Crispy Nachos",
            price: "£3.99",
            rating: "3.9",
            reviews: "26",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1534422298391-e4f8c172dddb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Guacamole Mex",
            content: "Mexican Chilli",
            price: "£3.99",
            rating: "4.2",
            reviews: "95",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1550461716-dbf266b2a8a7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Chillie Cake",
            content: "Deepfried Chicken",
            price: "£2.99",
            rating: "5.00",
            reviews: "61",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1476224203421-9ac39bcb3327??ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Nelli",
            content: "Hamburger & Fries",
            price: "£7.99",
            rating: "4.9",
            reviews: "89",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Jalapeno Poppers",
            content: "Crispy Soyabeans",
            price: "£8.99",
            rating: "4.6",
            reviews: "12",
            url: '/reservation'
        },
        {
            imageSrc:
                "https://images.unsplash.com/photo-1473093226795-af9932fe5856?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80",
            title: "Cajun Chicken",
            content: "Roasted Chicken & Egg",
            price: "£7.99",
            rating: "4.2",
            reviews: "19",
            url: '/reservation'
        }
    ];

    // Shuffle array
    return cards.sort(() => Math.random() - 0.5);
};

export const menuTakeaway = {
    'Pham Specials and Sashimi Set': {
        '_default': [],
        'Pham Specials': [
            {
                uid: 's01',
                imageSrc: image017,
                title: "Scallops with Creamy Spicy Sauce",
                content: "Grilled scallops with seaweed and tobiko, topped with a creamy spicy sauce",
                price: "£15.00",
                rating: "5.00",
                reviews: "87",
                url: '/reservation'
            },
            {
                uid: 's02',
                imageSrc: menuItemDefaultImg,
                title: "Snow Crab with Creamy Spicy Sauce",
                content: "Grilled snow crab meat on the bed of seaweed, tobiko, shitake mushroom topped with a creamy spicy sauce",
                price: "£15.00",
                rating: "4.8",
                reviews: "32",
                url: '/reservation'
            }
        ],
        'Specials Sashimi' : [
            {
                uid: 's03',
                imageSrc: image023,
                title: "Yellow Tail with Jalapeno (7 slices)",
                content: "Yellow tail sashimi with hint garlic & jalapenos pepper served with yuzu sauce",
                price: "£22.00",
                rating: "4.9",
                reviews: "89",
                url: '/reservation'
            },
            {
                uid: 's04',
                imageSrc: menuItemDefaultImg,
                title: "Seared Salmon with Jalapeno (7 slices)",
                content: "Seared salmon sashimi in Yuzu soy",
                price: "£18.00",
                rating: "4.6",
                reviews: "12",
                url: '/reservation'
            },
            {
                uid: 's05',
                imageSrc: menuItemDefaultImg,
                title: "Salmon New Style (7 slices)",
                content: "Seared salmon in sake soy",
                price: "£18.00",
                rating: "4.2",
                reviews: "19",
                url: '/reservation'
            },
            {
                uid: 's06',
                imageSrc: image021,
                title: "Tuna Tataki (7 slices)",
                content: "Seared tuna sashimi in ponzu sauce",
                price: "£20.00",
                rating: "5.00",
                reviews: "61",
                url: '/reservation'
            }
        ],
        'Sashimi set': [
            {
                uid: 'ss_ss01',
                imageSrc: menuItemDefaultImg,
                title: "Sashimi Moriawase (9 slices)",
                content: "Chef selection of sashimi",
                price: "£25.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_ss02',
                imageSrc: menuItemDefaultImg,
                title: "Sashimi Moriawase (15 slices)",
                content: "Chef selection of sashimi",
                price: "£38.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_ss03',
                imageSrc: menuItemDefaultImg,
                title: "Deluxe Sashimi Moriawase (25 slices)",
                content: "Chef’s selection of Sashimi",
                price: "£65.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
        'A la Carte Sashimi': [
            {
                uid: 'ss_alcs01',
                imageSrc: menuItemDefaultImg,
                title: "Salmon Sashimi",
                content: "5 Slices",
                price: "£12.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs02',
                imageSrc: menuItemDefaultImg,
                title: "Tuna Sashimi",
                content: "5 Slices",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs03',
                imageSrc: menuItemDefaultImg,
                title: "Seabream Sashimi",
                content: "5 Slices",
                price: "£12.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs04',
                imageSrc: menuItemDefaultImg,
                title: "Seabass Sashimi",
                content: "5 Slices",
                price: "£12.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs05',
                imageSrc: menuItemDefaultImg,
                title: "White Tuna (Escolar) Sashimi",
                content: "5 Slices",
                price: "£14.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs06',
                imageSrc: menuItemDefaultImg,
                title: "Yellow Tail Sashimi",
                content: "5 Slices",
                price: "£16.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs07',
                imageSrc: menuItemDefaultImg,
                title: "Turbot Sashimi",
                content: "5 Slices",
                price: "£14.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs08',
                imageSrc: menuItemDefaultImg,
                title: "Eel Sashimi",
                content: "5 Slices",
                price: "£14.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs09',
                imageSrc: menuItemDefaultImg,
                title: "Chu Toro Sashimi",
                content: "5 Slices",
                price: "£19.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcs10',
                imageSrc: menuItemDefaultImg,
                title: "O Toro Sashimi",
                content: "5 Slices",
                price: "£23.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ]
    },    
    'Sushi Roll, Sets and Nigiris': {
        "_default": [],
        'Sushi Sets (Chef’s Selection Sushi)': [
            {
                uid: 'ss_sscs01',
                imageSrc: menuItemDefaultImg,
                title: "Tuna and Salmon Sushi Set",
                content: "All Salmon & Tuna",
                price: "£26.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sscs02',
                imageSrc: image031,
                title: "Combination Sushi Set",
                content: "",
                price: "£35.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sscs03',
                imageSrc: image035,
                title: "Chef Set",
                content: "",
                price: "£35.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sscs04',
                imageSrc: image029,
                title: "Pham Set",
                content: "",
                price: "£34.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sscs05',
                imageSrc: menuItemDefaultImg,
                title: "Salmon Don",
                content: "",
                price: "£20.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sscs06',
                imageSrc: image093,
                title: "Chirashi Don",
                content: "",
                price: "£21.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sscs07',
                imageSrc: menuItemDefaultImg,
                title: "Tuna Don",
                content: "",
                price: "£22.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
        'A la Carte Nigiri (2 pieces)': [
            {
                uid: 'ss_alcn01',
                imageSrc: menuItemDefaultImg,
                title: "Salmon",
                content: "",
                price: "£6.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn02',
                imageSrc: menuItemDefaultImg,
                title: "Tuna",
                content: "",
                price: "£7.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn03',
                imageSrc: menuItemDefaultImg,
                title: "Chu Toro",
                content: "",
                price: "£9.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn04',
                imageSrc: menuItemDefaultImg,
                title: "O Toro",
                content: "",
                price: "£11.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn05',
                imageSrc: menuItemDefaultImg,
                title: "Seabass",
                content: "",
                price: "£6.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn06',
                imageSrc: menuItemDefaultImg,
                title: "Seabream",
                content: "",
                price: "£6.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn07',
                imageSrc: menuItemDefaultImg,
                title: "Yellow tail",
                content: "",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn08',
                imageSrc: menuItemDefaultImg,
                title: "Turbot",
                content: "",
                price: "£7.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn09',
                imageSrc: menuItemDefaultImg,
                title: "White Tuna (Escolar)",
                content: "",
                price: "£7.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn10',
                imageSrc: menuItemDefaultImg,
                title: "Eel",
                content: "",
                price: "£7.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn11',
                imageSrc: menuItemDefaultImg,
                title: "Prawn",
                content: "",
                price: "£6.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn12',
                imageSrc: menuItemDefaultImg,
                title: "Ikura",
                content: "",
                price: "£9.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn13',
                imageSrc: menuItemDefaultImg,
                title: "Special Salmon Nigiri",
                content: "",
                price: "£7.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_alcn14',
                imageSrc: menuItemDefaultImg,
                title: "Special Tuna Nigiri",
                content: "",
                price: "£8.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
        "Sushi Roll": [
            {
                uid: 'ss_sr01',
                imageSrc: menuItemDefaultImg,
                title: "Yellow Tail Crunchy Roll",
                content: "Big roll with yellow tail, tempura flake, spring onion, and masago",
                price: "£12.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },      
            {
                uid: 'ss_sr02',
                imageSrc: menuItemDefaultImg,
                title: "Yellow Tail Jalapeno Roll",
                content: "",
                price: "£11.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr03',
                imageSrc: image103,
                title: "Crunchy Tuna Roll",
                content: "Salmon, asparagus, spicy mayonaise, and tempura flakes topped with seared tuna and wasabi tobiko",
                price: "£12.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr17',
                imageSrc: menuItemDefaultImg,
                title: "Crunchy Salmon Roll",
                content: "",
                price: "£12.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr04',
                imageSrc: image101,
                title: "Pham Special Roll",
                content: "",
                price: "£14.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr05',
                imageSrc: menuItemDefaultImg,
                title: "Rainbow Roll",
                content: "Whitefish, tobiko, and spicy mayonaise roll wrapped in tuna, salmon, and avocado, topped it fried onion",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr06',
                imageSrc: menuItemDefaultImg,
                title: "Flying Dragon Roll",
                content: "Eel and Asparagusl with Tempura flakes in Avocado",
                price: "£16.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr07',
                imageSrc: menuItemDefaultImg,
                title: "Samurai Roll",
                content: "Prawn tempura with spicy sauce, topped with grilled eel, sliced jalapeno, and chili peppers",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr08',
                imageSrc: menuItemDefaultImg,
                title: "Soft Shell Crab Roll",
                content: "Whole deep-fried softshell crab, avocado, masago, and cucumber",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr09',
                imageSrc: menuItemDefaultImg,
                title: "King Prawn Tempura Roll",
                content: "Prawn tempura, avocado, and spicy mayonnaise",
                price: "£10.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr10',
                imageSrc: menuItemDefaultImg,
                title: "Alaska Roll",
                content: "Salmon, avocado, and mayonnaise",
                price: "£8.30",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr11',
                imageSrc: menuItemDefaultImg,
                title: "California Roll",
                content: "Crabstick, avocado, masago, and mayonnaise",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr12',
                imageSrc: menuItemDefaultImg,
                title: "Spicy Tuna Roll",
                content: "Tuna, spring onions, and spicy mayonnaise",
                price: "£8.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr13',
                imageSrc: menuItemDefaultImg,
                title: "Negi Toro Roll",
                content: "",
                price: "£10.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr14',
                imageSrc: menuItemDefaultImg,
                title: "Toro Crunchy Roll",
                content: "",
                price: "£16.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr15',
                imageSrc: menuItemDefaultImg,
                title: "Salmon Skin Roll",
                content: "",
                price: "£11.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ss_sr16',
                imageSrc: menuItemDefaultImg,
                title: "Spicy Salmon Truffle Roll",
                content: "",
                price: "£8.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
        'Vegan Sushi': [
            {
                uid: 'nvs_vs01',
                imageSrc: menuItemDefaultImg,
                title: "Mixed Veggie Roll",
                content: "",
                price: "£7.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'nvs_vs02',
                imageSrc: menuItemDefaultImg,
                title: "Cucumber Maki",
                content: "",
                price: "£5.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'nvs_vs03',
                imageSrc: menuItemDefaultImg,
                title: "Avocado Maki",
                content: "",
                price: "£6.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'nvs_vs04',
                imageSrc: menuItemDefaultImg,
                title: "Asparagus Maki",
                content: "",
                price: "£5.50",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'nvs_vs05',
                imageSrc: image037,
                title: "Deluxe Vegan Set",
                content: "",
                price: "£17.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'nvs_vs06',
                imageSrc: menuItemDefaultImg,
                title: "Inari Nigiri",
                content: "",
                price: "£5.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ]
    },
    'Tempura, Appetizers & Grilled Dish': { 
        '_default': [], 
        'Tempura (All Tempura dishes is containing Egg)': [
            {
                uid: 'ta_t01',
                imageSrc: image081,
                title: "Tempura Moriawase",
                content: "Mixture of Fish, Prawn & Vegetables",
                price: "£18.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_t02',
                imageSrc: image079,
                title: "Ebi Tempura",
                content: "5 piece of Prawn Tempura",
                price: "£18.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_t03',
                imageSrc: image083,
                title: "Vegetable Tempura",
                content: "",
                price: "£11.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_t04',
                imageSrc: image077,
                title: "Rock Shrimp Tempura in Spicy Sauce",
                content: "Shrimp in Spicy Mayo",
                price: "£16.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            // {
            //     uid: 'ta_t05',
            //     imageSrc: image085,
            //     title: "Softshell Crab Tempura",
            //     content: "Whole Crab with vegetables",
            //     price: "£8",
            //     rating: "3.9",
            //     reviews: "26",
            //     url: '/reservation'
            // }
        ], 
        'Appetizers': [
            {
                uid: 'ta_a01',
                imageSrc: image003,
                title: "Edamame (Salty or Spicy) V",
                content: "Steamed and salted soy beans",
                price: "£5.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            // {
            //     uid: 'ta_a02',
            //     imageSrc: image009,
            //     title: "Vegetable Spring Roll (V)",
            //     content: "",
            //     price: "£6.00",
            //     rating: "3.9",
            //     reviews: "26",
            //     url: '/reservation'
            // },
            {
                uid: 'ta_a03',
                imageSrc: menuItemDefaultImg,
                title: "Chicken Yakitori",
                content: "Grilled Chicken in Yakitori sauce, 2 skewers",
                price: "£10.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a04',
                imageSrc: menuItemDefaultImg,
                title: "Nasu Dengaku (V)",
                content: "Deep fried aubergine with sweet miso sauce",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a05',
                imageSrc: menuItemDefaultImg,
                title: "House Spring Rolls",
                content: "Minced pork and vegetables served with ponzu sauce, 3 pieces",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a06',
                imageSrc: image011,
                title: "Japanese Spring Rolls",
                content: "Prawn & Mushroom, 2 pieces",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a07',
                imageSrc: image007,
                title: "Age Dashi Tofu",
                content: "Deep fried bean curd topped with fish flakes served with tempura sauce",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a08',
                imageSrc: image005,
                title: "Chicken Gyoza",
                content: "Pan fried chicken and vegetable dumplings, 4 pieces",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a09',
                imageSrc: image005,
                title: "Pork Gyoza",
                content: "Pan fried pork and vegetable dumplings, 4 pieces",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a10',
                imageSrc: image001,
                title: "Chicken Karaage",
                content: "Japanese fried chicken",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a11',
                imageSrc: menuItemDefaultImg,
                title: "Deep Fried Squid Tentacles",
                content: "Served with Ponzu",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a12',
                imageSrc: menuItemDefaultImg,
                title: "Prawn Crunchy Bites",
                content: "Prawn with Pastry skin",
                price: "£8.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_a13',
                imageSrc: menuItemDefaultImg,
                title: "Octopus Ball",
                content: "Takoyaki with Octopus, topped with Bonito Flakes",
                price: "£7.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
        'Grilled Dishes': [
            {
                uid: 'ta_gd01',
                imageSrc: image039,
                title: "Black Cod Miso",
                content: "Black Cod marinated in Sweet Miso",
                price: "£30.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_gd02',
                imageSrc: menuItemDefaultImg,
                title: "Grilled Salmon with Miso",
                content: "Salmon marinated in Sweet Miso",
                price: "£22.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            // {
            //     uid: 'ta_gd03',
            //     imageSrc: menuItemDefaultImg,
            //     title: "Grilled Salmon Steak in Teriyaki",
            //     content: "Choice of Teriyaki or Wafu sauce",
            //     price: "£10.00",
            //     rating: "3.9",
            //     reviews: "26",
            //     url: '/reservation'
            // },
            // {
            //     uid: 'ta_gd04',
            //     imageSrc: menuItemDefaultImg,
            //     title: "Grilled Chicken in Teriyaki sauce",
            //     content: "",
            //     price: "£9.00",
            //     rating: "3.9",
            //     reviews: "26",
            //    url: '/reservation'
            // },
            // {
            //     uid: 'ta_gd05',
            //     imageSrc: menuItemDefaultImg,
            //     title: "Unagi Don",
            //     content: "",
            //     price: "£18.50",
            //     rating: "3.9",
            //     reviews: "26",
            //     url: '/reservation'
            // }
        ],
        'Salads': [
            {
                uid: 'ta_sal01',
                imageSrc: menuItemDefaultImg,
                title: "Seaweed Salad",
                content: "",
                price: "£10.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_sal02',
                imageSrc: menuItemDefaultImg,
                title: "Salmon Salad ( Seared)",
                content: "",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            // {
            //     uid: 'ta_sal03',
            //     imageSrc: menuItemDefaultImg,
            //     title: "Tuna Salad (Seared)",
            //     content: "",
            //     price: "£17.00",
            //     rating: "3.9",
            //     reviews: "26",
            //     url: '/reservation'
            // },
            {
                uid: 'ta_sal04',
                imageSrc: menuItemDefaultImg,
                title: "Chuka Salad",
                content: "",
                price: "£7.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_sal05',
                imageSrc: menuItemDefaultImg,
                title: "Mixed Leaf Salad with Avocado",
                content: "",
                price: "£10.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_sal06',
                imageSrc: image013,
                title: "Mixed Pickles",
                content: "",
                price: "£5.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'ta_sal07',
                imageSrc: menuItemDefaultImg,
                title: "Horenzo Goma-ea",
                content: "",
                price: "£5.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ] 
    },
    'Donburi, Bento’s & Platters': { 
        '_default': [], 
        'Donburi': [
            {
                uid: 'db_d01',
                imageSrc: image089,
                title: "Unagi Don",
                content: "Grilled eel on rice and pickles",
                price: "£20.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d02',
                imageSrc: menuItemDefaultImg,
                title: "Beef Steak Teriyaki",
                content: "",
                price: "£24.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d03',
                imageSrc: image091,
                title: "Tori Katsudon",
                content: "Chicken in breadcrumbs with egg on rice",
                price: "£16.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d04',
                imageSrc: menuItemDefaultImg,
                title: "Salmon Teriyaki",
                content: "Grilled salmon with teriyaki sauce served with vegetables",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d05',
                imageSrc: menuItemDefaultImg,
                title: "Chicken Teriyaki",
                content: "Grilled Chicken with teriyaki sauce served with vegetables",
                price: "£15.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d06',
                imageSrc: menuItemDefaultImg,
                title: "Salmon Katsu Curry",
                content: "Salmon with Breadcrumbs & Curry Sauce",
                price: "£18.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d07',
                imageSrc: menuItemDefaultImg,
                title: "Chicken Katsu Curry",
                content: "Crispy Chicken fillet with breadcrumbs served with japanese curry sauce",
                price: "£16.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d08',
                imageSrc: menuItemDefaultImg,
                title: "Ebi Katsu Curry",
                content: "",
                price: "£20.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d09',
                imageSrc: image095,
                title: "House Special Fried Rice",
                content: "",
                price: "£14.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d10',
                imageSrc: menuItemDefaultImg,
                title: "Egg Fried Rice",
                content: "",
                price: "£6.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d11',
                imageSrc: menuItemDefaultImg,
                title: "Sushi Rice",
                content: "",
                price: "£4.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_d12',
                imageSrc: menuItemDefaultImg,
                title: "Plain Rice",
                content: "",
                price: "£4.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ], 
        'Noodle Soup': [
            {
                uid: 'nvs_ns01',
                imageSrc: menuItemDefaultImg,
                title: "Miso Soup",
                content: "Tofu, Seaweed and spring onion in soy bean broth",
                price: "£3.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'nvs_ns02',
                imageSrc: menuItemDefaultImg,
                title: "Vegetable Soup",
                content: "",
                price: "£4.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
        'Bento Box': [
            {
                uid: 'db_b01',
                imageSrc: image049,
                title: "Chicken Teriyaki Bento",
                content: "Chicken, Rice, Salad, Salmon and Tuna Sashimi and Mixed Pickles",
                price: "£23.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_b02',
                imageSrc: menuItemDefaultImg,
                title: "Chicken Katsu Curry Bento",
                content: "Chicken Katsu with Miso Rice and Sashimi",
                price: "£24.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_b03',
                imageSrc: image051,
                title: "Tempura Bento",
                content: "Mix tempura with Miso soup, Rice and Sashimi",
                price: "£24.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_b04',
                imageSrc: image047,
                title: "Salmon Teriyaki Bento",
                content: "Salmon, Rice, Salad, Salmon and Tuna Sashimi and Mixed Pickles",
                price: "£24.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_b05',
                imageSrc: menuItemDefaultImg,
                title: "Tuna and Salmon Bento",
                content: "Served with Rice and Miso",
                price: "£25.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_b06',
                imageSrc: menuItemDefaultImg,
                title: "Tofu Bento (V)",
                content: "",
                price: "£20.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ], 
        'Platters': [
            {
                uid: 'db_p01',
                imageSrc: image069,
                title: "Yellow Tail with Jalapeno Platter",
                content: "Large Platter of Yellow Tail Sashimi with Jalapeno. 45-50 slices",
                price: "£115.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p02',
                imageSrc: image061,
                title: "Pham Platter",
                content: "Roll: Crunchy Tuna, Soft Shell Crab, Chef Special, Alaska, and Spicy Tuna. Nigiri: Tuna and Salmon. 3 kinds of Sashimi. 64 pieces",
                price: "£115.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p03',
                imageSrc: image067,
                title: "Omakase Platter",
                content: "A fresh selection of Sashimi present beautiful in a Large Platter, 55-60 slices",
                price: "£125.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p04',
                imageSrc: image065,
                title: "Platter for 2",
                content: "Share for 2 people. Yellow Tail Jalapeno, Salmon, Tuna & Whitefish Sashimi, Tuna & Seabass Nigiri, Crunchy Tuna & Pham Special Roll, and Seaweed Salad",
                price: "£80.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p05',
                imageSrc: image073,
                title: "Nigiri Platter",
                content: "5 of Each Salmon, Tuna, Escolar, Seabass and Prawn Nigiri, 10 pieces of California cut roll. 35 pieces",
                price: "£85.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p05',
                imageSrc: menuItemDefaultImg,
                title: "Hot Starter Platter",
                content: "Rock Shrimp, Chicken Katsu, Karaage, Vegetable Tempura, Yakitori and Edamame",
                price: "£85.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p06',
                imageSrc: image063,
                title: "Deluxe Sushi & Sashimi Platter",
                content: "Crunchy Yellow Tail, 3 kinds of Sashimi, 3 kinds of Nigiri, Crunchy Salmon, and Crunchy Tuna Roll and 2 King Prawn Tempura Rolls. 55 pieces",
                price: "£110.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p07',
                imageSrc: image059,
                title: "Classic Platter",
                content: "6 pieces of Chef Special Roll, 3 kinds of Sashimi, 2 Softshell Crab Rolls, 2 King Prawn Tempura Rolls, Salmon and Tuna Jalapeno Rolls, and 6 pieces of Nigiri. 60 pieces",
                price: "£110.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            },
            {
                uid: 'db_p08',
                imageSrc: image075,
                title: "Veggie Platter",
                content: "Vegetable sushi and vegan salmon tuna sashimi",
                price: "£65.00",
                rating: "3.9",
                reviews: "26",
                url: '/reservation'
            }
        ],
    }
};
